import { type MapBounds } from "../types";

/** BE が受け付ける範囲の最大幅（緯度・経度とも、度）。 */
export const MAX_BBOX_SPAN_DEGREES = 2;

/** 緯度経度を、BE が受け付ける小数6桁に丸める。 */
const round6 = (value: number): number => Math.round(value * 1e6) / 1e6;

/**
 * 地図の表示範囲が、ピンを取得できる大きさか。広すぎる範囲は問い合わせない（BE が 400 を返す）。
 * @param bounds - 表示範囲
 * @returns 取得できる大きさなら true
 */
export const isPinSearchableBounds = (bounds: MapBounds): boolean =>
  bounds.north - bounds.south <= MAX_BBOX_SPAN_DEGREES &&
  bounds.east - bounds.west <= MAX_BBOX_SPAN_DEGREES;

/**
 * 表示範囲を、ピン取得APIのクエリに変換する。
 * @param bounds - 表示範囲
 * @returns south / west / north / east（小数6桁）
 */
export const toPinQuery = (bounds: MapBounds): Record<string, number> => ({
  south: round6(bounds.south),
  west: round6(bounds.west),
  north: round6(bounds.north),
  east: round6(bounds.east),
});
